import { DataContext } from "../../helper/HelperOne"
import NavBar from "../nav_bar/Navbar"
import { useState } from "react"
import LeadRoleAssignCreate from "./LeadRoleAssignCreate"

function LeadRoleAssign() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<LeadRoleAssignCreate/>}
                menuId={6}
            />
        </DataContext.Provider>
    )
}

export default LeadRoleAssign